import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { CheckboxListComponent } from "@components/checkbox-list/checkbox-list.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { Observable, of } from "rxjs";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-transporthandelse-filter",
    templateUrl: "./tpl-transporthandelse-filter.component.html",
    styleUrls: ["./tpl-transporthandelse-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxListComponent
    ]
})
export class TplTransporthandelseFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {

    @Input() dataSource: ITplArbetsorder[];

    options: Observable<string[]>;

    private static readonly Planerad = "Planerad";

    private static readonly Pagaende = "Pågående";

    constructor() {
        super("transporthandelse");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    onFilterInit(state: any): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    match(item: ITplArbetsorder): boolean {
        const values = this.value();
        const expectedPlanerad = values.some(x => x === TplTransporthandelseFilterComponent.Planerad);
        const expectedPagaende = values.some(x => x === TplTransporthandelseFilterComponent.Pagaende);

        const now = new Date();
        const isPagaende = !!item.transportPaborjadDatum && item.transportPaborjadDatum < now && (item.transportAvslutadDatum == null || item.transportAvslutadDatum > now);

        const planeradMatch = expectedPlanerad && item.periodStart >= now && !isPagaende;
        const pagaendeMatch = expectedPagaende && isPagaende;

        return planeradMatch || pagaendeMatch;
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: string[]): void {
        this.filterLength = !value ? 0 : value.length;
    }

    private initOptions(): void {
        const options = [
            TplTransporthandelseFilterComponent.Planerad,
            TplTransporthandelseFilterComponent.Pagaende
        ];
        this.options = of(options);
    }
}
